<template>
  <!-- v-if="storeTips" ?-->
  <v-layout justify-center row wrap>
    <b class="pt-3 py-2">
      {{ label }}
    </b>
    <br>

    <v-flex v-if="!showManualTip && storeTips.length" xs12 class="text-xs-center ">
      <v-btn-toggle
        v-model="tipIndex"
        class="elevation-3 tip-buttons"
        @change="onTip(storeTips[tipIndex])"
      >
        <v-btn v-for="(tip, index) in storeTips"
          :key="tip.amount"
          flat
          block
          @click="showManualTip = false; manulTipAmount = null"
          :disabled="isTipDisabled(index)"
        >
          {{tip.amount}}%
        </v-btn>

        <v-btn flat block @click="toggleManual"
         v-if="!mandatoryTip() || type != 'DRIVER'"
        >
          {{ $vuetify.t('$vuetify.common.edit') }}
        </v-btn>
      </v-btn-toggle>
    </v-flex>

    <v-layout v-else justify-center row wrap class="fullWidth">
      <v-flex xs10 class="text-xs-center">
        <v-text-field
          name="manualTip"
          type="number"
          prepend-icon="attach_money"
          :label="$vuetify.t('$vuetify.cart.tip')"
          v-model="manulTipAmount"
          @input="onManualTip"
          @blur="validateManual"
          @keypress="checkNumberRegex"
          onclick="this.select()"
          onfocus="this.select()"
          min="0"
          ref="ManualTipAmount"
        />
      </v-flex>

      <v-flex xs2 v-if="storeTips.length" id="closeContainer">
        <v-btn outline  color="primary" style="">
          <v-icon @click="toggleManual(false)">
            close
          </v-icon>
        </v-btn>
      </v-flex>
    </v-layout>
  </v-layout>
</template>

<script>
import get from 'lodash/get';

import { mapMutations, mapActions, mapGetters } from 'vuex';

export default {
  props: {
    amount: Number,
    percent: Number,
    label: String,
    type: String,
    setDefault: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      tipIndex: -1,
      // tipsPercent: 0,
      showManualTip: false,
      manulTipAmount: 0,
      mandatoryTipForThirdPartyDelivery: false,
      tipsAmount: this.amount
    }
  },

  computed: {
    storeTips() {
      return get(this.getStore, `settings.${this.getOrderType.toLowerCase()}Settings.tips`, null)
        || this.getStore.settings.tips
        || this.getStore.tips
        || []
    },

    tipsPercent: {
      get() {
        return this.percent
      },
      set(value) {
        this.$emit('update:percent', value)
      }
    },

    ...mapGetters([
      'getStore',
      'getCheckoutInfo',
      'getBill',
      'getOrderType',
      'isBillLoading'
    ])
  },

  methods: {
    isTipDisabled(index) {
      if (this.mandatoryTipForThirdPartyDelivery && this.type == 'DRIVER'){
        return this.tipIndex == index
      } else {
        return false
      }
    },
    mandatoryTip() {
      const mandatoryTip = get(this.getStore, 'settings.orderSettings.mandatoryTipForThirdPartyDelivery', false)
      this.mandatoryTipForThirdPartyDelivery = mandatoryTip
      return mandatoryTip
    }, 
    calcTipPercent(tipsPercent = this.tipsPercent) {
      return +(this.getBill.orderAmount * (tipsPercent / 100)).toFixed(2)
    },
    onTip(tip) {
      let newAmount = !!tip && this.tipIndex >= 0 ? tip.amount : 0
      if (this.mandatoryTipForThirdPartyDelivery && tip) {
        newAmount = tip.amount
      }
      this.tipsPercent = newAmount
      this.emitAmount(this.calcTipPercent(newAmount))
    },

    toggleManual(val = !this.showManualTip) {
      this.showManualTip = val
      this.manulTipAmount = 0
      this.emitAmount(0)

      // Default to the first tip on close
      this.$nextTick(() => {
        if (!this.showManualTip) {
          this.findDefault()
        } else {
          this.$refs.ManualTipAmount.focus()
        }
      })
    },
    onManualTip(input) {
      this.emitAmount(+input)
      this.tipsPercent = null
    },
    validateManual() {
      this.$set(this, 'manulTipAmount', (+this.manulTipAmount).toFixed(2))
    },

    emitAmount(amount) {
      this.tipsAmount = amount
      this.$emit('update:amount', amount)
    },

    findDefault() {
      // Otherwise, we set a default amount on the first tip input
      let tipIdx = this.storeTips.findIndex(tip => tip.default)

      if (tipIdx >= 0) {
        // Tip index is used in onTip
        this.tipIndex = tipIdx
        this.onTip(this.storeTips[tipIdx])
      }
    },

    checkNumberRegex(e) {
      if (e.key == '-' || e.key == 'e' || e.key == 'E')
        event.preventDefault()
    },

    ...mapMutations([ 'SET_CHECKOUT_INFO' ])
  },

  mounted() {
    if (this.storeTips) {
      // If the tip amount is set before hand, find the amount that relates to it
      if (this.amount) {
        this.storeTips.forEach((tipsPercent, i) => {
          // Look for a preset percentage that relates to the amount provided
          if (this.tipsPercent == tipsPercent.amount || this.amount == this.calcTipPercent(tipsPercent.amount)) {
            this.tipIndex = i
            this.onTip(tipsPercent)
          }
        })

        // If the index could not be found, show it in manual input
        if (this.tipIndex < 0) {
          this.showManualTip = true
          this.manulTipAmount = this.amount
          this.validateManual()
        }
      } else if (this.setDefault) {
        this.findDefault()
      }
    }
  }
}
</script>

<style scoped>
  .tip-buttons .v-btn--active {
    color: white !important;
    background: var(--v-primary-base) !important;
  }

  #closeContainer {
    position: relative;
  }
  #closeContainer button {
    position: absolute;
    bottom: 19px;
    right: 5px;

    min-width: 0 !important;
    width: 35px !important;
    padding: 0;
    margin: 0
  }

  /* #closeContainer {
    position: relative;
  }
  #closeContainer i {
    position: absolute;
    bottom: 20px;
    right: 5px
  } */
</style>
